import React, {Component} from 'react';
import { fixDecimals } from '../../../helpers/helpers';
import * as DateFns from 'date-fns';

const d3 = require('d3');

class PacketGraphD3 {
  constructor(data, width, height) {
    this.width = width;
    this.height = height;
    this.data = data;
  }

  buildBase(node) {
    this.node = node;
    const config = {
      colorTextTooltip: '#7E7E7E',
      colorTextAxis: '#666666',
      colorDashedLine: '#CDCDCD',
      colorLineTop: '#84BD84',
      colorLineBottom: '#F58484',
      strokeLine: '1px',
    };
    const container = d3.select(this.node)
      .attr('style', `width: ${this.width}px; height: ${this.height}px; overflow-x: visible;`)
      .attr('class', 'packet-graph');
    // TITLE
    // const title = container.append('div')
    //   .attr('style', 'display: flex;');
    // title.append('h6')
    //   .text('N Packets vs T')
    //   .attr('style', 'flex-grow: 1; text-align: right;');
    // title.append('h6')
    //   .text('T Packet')
    //   .attr('style', 'flex-grow: 1;');
    const titleHeight = 0;
    // ENT TITLE

    const svg = container.append('svg');
    const widthAxisLeft = 30;
    const widthAxisBottom = 100;
    const widthChart = this.width - widthAxisLeft;
    const heightChart = this.height - titleHeight - widthAxisBottom;
    const data = this.data
      .filter((d) => !Number.isNaN(+d.locate_value))
      .filter((d) => !Number.isNaN(+d.non_locate_value))
      .filter((d) => !Number.isNaN(+d.time))
      .sort((d1, d2) => +d1.time - +d2.time);
    svg
      .attr('width', this.width)
      .attr('height', this.height - titleHeight)
      .attr('style', 'overflow: visible;')
      .attr('viewBox', `0 0 ${this.width} ${heightChart}`); // width height

    // SCALES
    const scaleX = d3.scaleBand()
      .domain(data.map(d => new Date(d.time * 1000)))
      .range([0, widthChart]); // width

    const scaleY = d3.scaleLinear()
      .domain([0, 100])
      .range([heightChart, 0]); //height
    const trans = (x, y) => `translate (${x}, ${y})`;

    // AXIS
    const axis = svg.append('g')
      .attr('transform', trans(widthAxisLeft, 0));
    axis.append('g') // axisY
      .attr('transform', trans(0, 0))
      .call(d3.axisLeft(scaleY).tickSize(-widthChart))
      .call(g => g.select('.domain').remove()) // width
      .call(g => g.selectAll('text')
        .attr('fill', config.colorTextAxis)
        .attr('transform', trans(0, 0)))
      .call(g => g.selectAll('line')
        .attr('stroke', config.colorDashedLine)
        .attr('stroke-width', 1)
        .style("stroke-dasharray", ("3, 3")));
    const V = [];
    let l = 0;
    axis.append('g') // axisX
      .attr('transform', trans(-scaleX.bandwidth() / 2, heightChart)) // height
      .call(d3.axisBottom(scaleX).tickSize(-heightChart).tickFormat((d, i) => l++))
      .call(d3.axisBottom(scaleX).tickSize(-heightChart).tickFormat((d, i) => { // height
        const axisBottomShow = l <= 10 ? 1 : ~~(l / 10);
        if (i % axisBottomShow === 0 || i === l - 1) {
          V.push(d);
          return DateFns.format(d, 'HH:mm:ss');
        }
        return "";
      }))
      .call(g => g.select('.domain').remove())
      .call(g => g.selectAll('text')
        .attr('fill', config.colorTextAxis)
        .attr('transform', `rotate(-45) translate(${-20}, ${0})`))
      .call(g => g.selectAll('line')
        .attr('stroke', config.colorDashedLine)
        .attr('stroke-width', 1)
        .style("stroke-dasharray", ("3, 3")))
      .call(g => g.selectAll('line').filter(d => V.indexOf(d) === -1)
        .attr('opacity', 0));

    // PATHS
    const paths = svg.append('g')
      .attr('transform', trans(widthAxisLeft, 0));
    paths.append('path')
      .datum(data)
      .attr('d', d3.line()
        .x(d => scaleX(new Date(d.time * 1000)))
        .y(d => scaleY(d.locate_value))
        .curve(d3.curveMonotoneX)
      )
      .style('stroke', config.colorLineTop)
      .style('stroke-width', config.strokeLine)
      .style('fill', 'none')
      .attr('stroke-linecap', 'round');

    paths.append('path')
      .datum(data)
      .attr('d', d3.line()
        .x(d => scaleX(new Date(d.time * 1000)))
        .y(d => scaleY(d.non_locate_value))
        .curve(d3.curveMonotoneX)
      )
      .style('stroke', config.colorLineBottom)
      .style('stroke-width', config.strokeLine)
      .style('fill', 'none')
      .attr('stroke-linecap', 'round');

    // CIRCLES PLUS TOOL TIP
    const toolTip = paths;
    const circleFocus = toolTip
      .append('g')
      .append('circle')
      .attr("stroke", "#FFFFFF")
      .attr('r', 6.5)
      .style("fill", config.colorLineTop)
      .style("opacity", 0);

    const circleBottom = toolTip
      .append('g')
      .append('circle')
      .attr('stroke', '#FFFFFF')
      .attr('r', 6.5)
      .style('fill', config.colorLineBottom)
      .style('opacity', 0);

    const xx = -1000000, yy = -1000000;
    const rectangleMarginToolTip = toolTip
      .append('rect')
      .attr("width", "102")
      .attr("height", "52")
      .style("fill", config.colorDashedLine)
      .attr("x", scaleX(xx))
      .attr("y", scaleY(yy));
    const rectangleToolTip = toolTip
      .append('rect')
      .attr("width", "100")
      .attr("height", "50")
      .style("fill", "#FFFFFF")
      .attr("x", scaleX(xx))
      .attr("y", scaleY(yy));
    const lineTooltip = toolTip
      .append("line")
      .attr("x1", xx)
      .attr("y1", yy)
      .attr("x2", xx)
      .attr("y2", yy)
      .attr("stroke-width", 1)
      .attr('stroke', config.colorDashedLine);
    const textTimeToolTip = toolTip
      .append('text')
      .text("04:22:22")
      .attr("font-size", "10")
      .attr("fill", config.colorTextTooltip)
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 600')
      .attr("x", scaleX(xx))
      .attr("y", scaleY(yy) + 50);
    const textTopToolTip = toolTip
      .append('text')
      .text("T Packet")
      .attr("font-size", "10")
      .attr("fill", config.colorLineTop)
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 600')
      .attr("x", scaleX(xx))
      .attr("y", scaleY(yy) + 15);
    const textBottomToolTip = toolTip
      .append('text')
      .text("MPH")
      .attr("font-size", "10")
      .attr("fill", config.colorLineBottom)
      .attr('style', 'font-family: \'Roboto Condensed\'; font-weight: 600')
      .attr("x", scaleX(xx))
      .attr("y", scaleY(yy) + 30);

    // END TOOLTIP
    // for the mouse
    toolTip
      .append('rect')
      .style("fill", "none")
      .style("pointer-events", "all")
      .attr('width', widthChart)
      .attr('height', heightChart)
      .on('mouseover', mouseover)
      .on('mousemove', mousemove);

    // What happens when the mouse move -> show the annotations at the right positions.
    function mouseover() {
      if (data.length < 1) return;
      circleFocus.style("opacity", 1);
      circleBottom.style("opacity", 1);
    }

    function mousemove(event) {
      if (data.length < 1) return;
      // recover coordinate we need
      scaleX.invert = function (x) {
        return d3.scaleQuantize().domain(this.range()).range(this.domain())(x);
      };
      const x = scaleX.invert(d3.pointer(event)[0]);

      const right = d3.pointer(event)[0] > widthChart / 2;
      const pointTop = {x: 0, y: 0}, //p2 = {x: 1, y: 1},
        pointBottom = {x: 0, y: 0}; //p2r = {x: 1, y: 1};
      let sw = true;
      data.forEach((d, i) => {
        if (sw && +d.time * 1000 >= x && i > 0) {
          pointTop.x = +d.time * 1000;
          pointTop.y = d.locate_value;
          pointBottom.x = +d.time * 1000;
          pointBottom.y = d.non_locate_value;
          sw = false;
        }

      });
      lineTooltip
        .attr("x1", scaleX(x))
        .attr("y1", scaleY(pointTop.y) + 8)
        .attr("x2", scaleX(x))
        .attr("y2", scaleY(pointBottom.y) - 8);
      circleFocus
        .attr("cx", scaleX(x))
        .attr("cy", scaleY(pointTop.y));
      circleBottom
        .attr('cx', scaleX(x))
        .attr('cy', scaleY(pointBottom.y));
      const yAxis = ((scaleY(pointTop.y) + scaleY(pointBottom.y)) / 2) - 30;

      rectangleToolTip
        .attr("x", scaleX(x) + 5 - (right ? 110 : 0))
        .attr("y", yAxis);
      rectangleMarginToolTip
        .attr("x", scaleX(x) + 4 - (right ? 110 : 0))
        .attr("y", yAxis - 1);

      textTimeToolTip
        .text(DateFns.format(x, 'HH:mm:ss'))
        .attr("x", scaleX(x) + 10 - (right ? 110 : 0))
        .attr("y", yAxis + 15);
      textTopToolTip
        .text("T Packets: " + fixDecimals(pointTop.y, 1))
        .attr("x", scaleX(x) + 10 - (right ? 110 : 0))
        .attr("y", yAxis + 29);
      textBottomToolTip
        .text("N Packets: " + fixDecimals(pointBottom.y, 1))
        .attr("x", scaleX(x) + 10 - (right ? 110 : 0))
        .attr("y", yAxis + 42);
    }
  }
}

const react = React.createElement;
export default class PacketGraph extends Component {
  constructor(props) {
    super(props);
    this.PacketGraph = new PacketGraphD3(this.props.data, this.props.width || Math.max(this.props.config.data.length * 5, 200), this.props.height || 100);
  }

  render() {
    return react('div', {ref: (node => this.node = node)});
  }

  componentDidMount() {
    this.PacketGraph.buildBase(this.node);
  }
}
